import { Patient } from './patient.model';
import { StringUtils } from '../shared/utils/string-utils';

/** Case-insensitive trimmed name for exact patient match. */
export function normalizePatientName(name: string | undefined): string {
  return (name ?? '').trim().toLowerCase();
}

/** Digits-only phone for exact patient match. */
export function normalizePatientPhone(phone: string | undefined): string {
  return StringUtils.stripNonDigits(phone ?? '');
}

/**
 * Exact match on patient name + phone (case-insensitive name; digit-normalized phone).
 * Shared helper for standalone add guard; reusable for Epic open-existing later.
 */
export function findExactPatientMatch(
  patients: readonly Patient[],
  name: string,
  phone: string,
): Patient | undefined {
  const normalizedName = normalizePatientName(name);
  const normalizedPhone = normalizePatientPhone(phone);
  if (!normalizedName || !normalizedPhone) {
    return undefined;
  }

  return patients.find(
    (patient) =>
      normalizePatientName(patient.name) === normalizedName &&
      normalizePatientPhone(patient.phone) === normalizedPhone,
  );
}
